export const endpointUrl = import.meta.env.VITE_PROPERTY_ADMIN_GRAPHQL ?? ''
export const propertyAPI = import.meta.env.VITE_PROPERTY_API || ''
export const bafUrl = import.meta.env.VITE_BAF_URL || ''
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT ?? ''
export const environment = import.meta.env.VITE_ENV || ''
export const isInProduction = environment === 'production'
export const isInDevelopment = environment === 'development'
export const isInTest = environment === 'test'
export const isInConversion = environment === 'conversion'
export const isInRelease = environment === 'release'
export const isInStage = environment === 'stage'
export const isInCert = environment === 'cert'
export const isInValid = environment === 'valid'
export const isInProductionLike = isInProduction || isInStage || isInRelease || isInCert
export const isByPassDisabled = import.meta.env.VITE_DISABLE_BYPASS_PERMISSIONS === 'true'

const title: { [key: string]: string } = {
  development: 'DEV',
  test: 'TEST',
  conversion: 'CONV',
  stage: 'STAGE',
  release: 'RELEASE',
  cert: 'CERT',
  valid: 'VALID',
}
export const showEnv = title[environment] ?? ''

if (showEnv === title.test) {
  process.env.TZ = import.meta.env.VITE_TZ || 'UTC'
}
